import { IOlympiadExam } from "../models/olympiadExam";

export const OlympiadExamConstants = [
    {
        examId: 4,
        examName: 'C-BAT'
    },
    {
        examId: 6,
        examName: 'A-MAT'
    },
    {
        examId: 2,
        examName: 'R-MM'
    },

    {
        examId: 5,
        examName: 'R-SM'
    },
    {
        examId: 7,
        examName: 'T-EAT'
    },
    {
        examId: 3,
        examName: 'B-MAT'
    },
    {
        examId: 9,
        examName: 'KCCM'
    },
    {
        examId: 8,
        examName: 'JSC'
    },
    {
        examId: 1,
        examName: 'K-SAT'
    },
    {
        examId: 10,
        examName: 'B.V.V.S'
    },
    {
        examId: 11,
        examName: 'APPUSMA'
    },
    {
        examId: 12,
        examName: 'TRSMA'
    },
    {
        examId: 13,
        examName: 'PSPA'
    }






] as IOlympiadExam[]

export const OlympiadExamData = {
    CBAT: OlympiadExamConstants[0],
    AMAT: OlympiadExamConstants[1],
    RMM: OlympiadExamConstants[2],
    RSM: OlympiadExamConstants[3],
    TEAT: OlympiadExamConstants[4],
    BMAT: OlympiadExamConstants[5],
    KCCM: OlympiadExamConstants[6],
    JSC: OlympiadExamConstants[7],
    KSAT: OlympiadExamConstants[8],
    BVVS: OlympiadExamConstants[9],
    APPUSMA:OlympiadExamConstants[10],
    TRSMA:OlympiadExamConstants[11],
    PSPA:OlympiadExamConstants[12],
}   
